import { IFilter } from 'react-angle-dashboard-components'

export const filters: IFilter[] = [
  {
    filterKey: 'distance',
    type: 'radio',
    name: 'Distance',
    value: 50,
    options: [
      {
        label: 'Within 1 mile',
        value: 1
      },
      {
        label: 'Within 5 miles',
        value: 5
      },
      {
        label: 'Within 10 miles',
        value: 10
      },
      {
        label: 'Within 20 miles',
        value: 20
      },
      {
        label: 'Within 50 miles',
        value: 50
      }
    ]
  },
  {
    filterKey: 'service',
    type: 'checkbox',
    name: 'Facility Type',
    value: {}
  }
]

export const getFacilityTypeIndex = (): number =>
  filters.findIndex((f: any) => f.filterKey === 'service')

export const getDistanceIndex = (): number =>
  filters.findIndex((f: any) => f.filterKey === 'distance')
